import { FC } from "react";

import { SecondaryOverlay } from "components/constants";
import { t } from "i18n/i18n";
import { Button } from "mds/components/Button";
import { IconText } from "mds/components/IconText";
import { MenuItem } from "mds/components/Menu";
import { InstructorNotesIcon } from "mds/icons";
import { useOverlayControls } from "utils/routing/hooks/use-overlay-controls";

export const InstructorNotesPanelToggleButton: FC<{
  isMobile?: boolean;
  isMenuItem?: boolean;
}> = ({ isMobile = false, isMenuItem = false }) => {
  const { isSelected, togglePanel } = useOverlayControls(SecondaryOverlay.InstructorNotes);

  if (isMenuItem) {
    return (
      <MenuItem
        eventName="Page Notes - Toggle"
        eventProps={{ isOpened: !isSelected }}
        onClick={togglePanel}
      >
        <IconText
          iconStart={<InstructorNotesIcon />}
          text={t("content_sidebar.title.InstructorNotes")}
        />
      </MenuItem>
    );
  }

  return (
    <Button
      eventName="Page Notes - Toggle"
      eventProps={{ isOpened: !isSelected }}
      isSelected={isSelected}
      kind="squareLegacy"
      size={isMobile ? "xl" : "l"}
      title={t("content_sidebar.title.InstructorNotes")}
      isSquare
      onClick={togglePanel}
    >
      <InstructorNotesIcon size={isMobile ? "l" : "m"} />
    </Button>
  );
};
